// The minimum allowed bid increment for a lot: 5% of its starting price, rounded
// up to the nearest 5 (with a floor of 5) so it's always at least the true 5%
// amount rather than a rounded-down approximation. Used both to auto-fill a
// sensible default increment and to enforce the "not less than 5%" rule.
export const computeMinIncrement = (startingPrice) => {
    const price = Number(startingPrice) || 0;
    if (price <= 0) return 5;
    return Math.max(5, Math.ceil((price * 0.05) / 5) * 5);
};
